export const DEFAULT_TIME_FORMAT = 'h:mm a';
export const DEFAULT_HOUR_INTERVAL = 1;
export const DEFAULT_MINUTE_INTERVAL = 1;
export const MIN_HOUR_VALUE = 0;
export const MAX_HOUR_VALUE = 23;
export const DEFAULT_HOUR_LABEL = 'Hour';
export const DEFAULT_MINUTE_LABEL = 'Minutes';
export const DEFAULT_APM_LABEL = ' ';
